const CustomerCard = ({ order }) => {
  return (
    <div className="bg-white rounded-xl p-4 shadow">
      <h2 className="font-semibold mb-2">Customer</h2>

      <p>{order.customer_info.firstname}</p>
      <p className="text-gray-500">{order.customer_info.email}</p>

      <div className="flex gap-2 mt-3">
        <button className="flex-1 border rounded-lg py-2">Email details</button>
        <button className="flex-1 border rounded-lg py-2">Phone details</button>
      </div>
    </div>
  );
};

export default CustomerCard;
